<template lang="pug">
  #program-card
    .columns
      .column
        figure.image.is-rounded
          img(
            :src="_.get(program, 'programLogo', require('@/assets/icons/logo.svg'))"
            alt="Program Logo"
            @error="programLogoOnError"
          )
      .column.is-two-thirds
        WtTitle(h4) {{ program.name }}
        p
          span.has-text-weight-semibold Created:&nbsp;
          | {{ date(program.startDate, "DATE_FORMAT_SLASH").formatted }}
    .column.level
      p.has-text-weight-semibold Administrator:
      p {{ supportEmailText }}
    .level(v-if="program.supportEmail")
      WtButton.level-item.contact-button(
        v-if="program.supportEmail"
        @click.native="contactModalOpen = true"
      ) CONTACT PROGRAM ADMIN

    BModal(:active.sync="contactModalOpen" :width="480")
      .modal-card(style='width: auto')
        header.modal-card-head
          p.modal-card-title Contact Your Program Administrator
        section.modal-card-body
          BNotification(
            type="is-info"
            has-icon
            :closable="false"
           ) {{ contactModalText }}
          BField(
            :type="{ 'is-danger': errors.has('message') }"
            :message="errors.first('message')"
          )
            BInput(
              name="message"
              type='textarea',
              v-model='body',
              placeholder='Your message here'
              maxlength="1000"
              v-validate.disable="'required'"
            )
        footer.modal-card-foot
          WtButton(@click.native="send") Send
          WtButton(
            color="lightgrey"
            @click.native="contactModalOpen = false"
          ) Cancel
</template>

<script>
import { mapActions } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import { dateUtilityMixin } from "../../mixins/dateUtilityMixin";
import BModal from "buefy/src/components/modal/Modal";

export default {
  name: "ProgramCard",

  components: { BModal, WtTitle, WtButton },

  mixins: [dateUtilityMixin],

  props: {
    program: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      contactModalOpen: false,
      body: ""
    };
  },

  computed: {
    supportEmailText() {
      if (this.program.supportEmail) {
        return this.program.supportEmail;
      } else {
        return "*No support email entered*";
      }
    },

    contactModalText() {
      return `
        The message you send here will be sent to your program administrator,
        and will contain your email address so that they may reply.
      `;
    }
  },

  watch: {
    contactModalOpen() {
      // clear the body when modal is opened or closed
      this.body = "";
    }
  },

  methods: {
    ...mapActions("program", ["emailAdministrator"]),
    ...mapActions(["snackBar"]),

    send() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          const payload = {
            programId: this.program.id,
            body: this.body
          };

          await this.emailAdministrator(payload);

          this.contactModalOpen = false;
          this.snackBar({ message: "Your message was sent successfully!" });
        }
      });
    },

    programLogoOnError(event) {
      event.target.onerror = null;
      event.target.src = require("@/assets/icons/logo.svg");
    }
  }
};
</script>

<style lang="sass" scoped>
#program-card
  .contact-button
    margin-top: 2rem
</style>
